import Select from 'components/form/Inputs/Select';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR, { mutate } from 'swr';
import Mentorship from 'types/Mentorship';
import MentorshipReferee from 'types/MentorshipReferee';
import privateAPI from 'utils/privateAxiosInstance';

type Props = {
  mentorship: Mentorship | undefined;
};
const ChangeReferee: FC<Props> = ({ mentorship }) => {
  const { data: referees } = useSWR<MentorshipReferee[]>('/mentorship-referee');
  const [refereeId, setRefereeId] = useState<number | null>(
    mentorship?.refereeId || null,
  );

  const { id: menteeId } = useParams();

  useEffect(() => {
    setRefereeId(mentorship?.refereeId || null);
  }, [mentorship]);

  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    const id = e.target.value ? parseInt(e.target.value) : null;
    setRefereeId(id);
    mutate(
      `/mentorship/mentee/${menteeId}/ongoing/`,
      { mentorship: { ...mentorship, refereeId: id } },
      false,
    );
    privateAPI
      .post(`/mentorship-referee/set/${mentorship?.id}`, { id })
      .catch(() => {
        mutate(`/mentorship/mentee/${menteeId}/ongoing/`);
      });
  };

  return (
    <Select
      label="Chargé de mentorat"
      value={refereeId?.toString() || ''}
      onChange={handleChange}
    >
      <option value="">-- Sélectionner un chargé de mentorat --</option>
      {referees?.map((referee, idx) => (
        <option value={referee.id} key={idx}>
          {referee.name}
        </option>
      ))}
    </Select>
  );
};

export default ChangeReferee;
